module.exports = __webpack_public_path__ + "static/img/keep_benefit_coffee_display.ec4e8d53.png";